export default "__VITE_ASSET__CqM$h$yX__"